import { ISlideData } from '@tencent/slide-sdk-model';
import { LegacySlideType, SlideImageType, SlideTag, SlideTagExtra, LegacySlideTag, SlideType } from '../define';
import { traverseTags } from '../schema';
import { parseJson } from './utils';

const mappingSlideType: Record<LegacySlideType, SlideType> = {
  [LegacySlideType.cover]: SlideType.cover,
  [LegacySlideType.catalogue]: SlideType.catalogue,
  [LegacySlideType.session]: SlideType.session,
  [LegacySlideType.page]: SlideType.page,
  [LegacySlideType.ending]: SlideType.ending,
};

export const convertSlideType = (type: SlideType | LegacySlideType): SlideType => {
  if (mappingSlideType[type]) return mappingSlideType[type];
  return type as SlideType;
};

export const getSlideTag = (slideData: ISlideData): SlideTag | undefined => {
  if (!slideData.cSld.spTree) return;

  const descr = slideData.cSld.spTree.nvPr.descr;
  if (!descr) return;

  const tag = parseJson<LegacySlideTag>(descr);
  if (!tag) return;

  return {
    ...tag,
    type: convertSlideType(tag.type),
  };
};

export const getSlideTagExtra = (slideData: ISlideData): SlideTagExtra | undefined => {
  if (!slideData.cSld.spTree) return;

  const descr = slideData.cSld.spTree.nvPr.descr;
  if (!descr) return;

  const tag = parseJson<LegacySlideTag>(descr);
  if (!tag) return;

  const { schema, idMap } = traverseTags(slideData.cSld.spTree.shapeList, undefined, undefined);

  return {
    // 旧数据兼容
    type: convertSlideType(tag.type),
    idMap,
    schema,
    imageType: getSlideImageType(schema),
  };
};

const getSlideImageType = (schema) => {
  if (schema.properties.image) return SlideImageType.Page;
  if (schema.properties.list?.items.properties.image) return SlideImageType.List;
  return SlideImageType.None;
};
